var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-main"},[_c('div',{staticClass:"login-main-title"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_c('loginVue',{on:{"child-event":_vm.closeClick}}),_c('div',{staticClass:"footer"},[_c('span',{on:{"click":_vm.registerClick}},[_vm._v("注册账号")])])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }